import { render, staticRenderFns } from "./ItemFilterRealBuyLayout.vue?vue&type=template&id=501d8f10&scoped=true"
import script from "./ItemFilterRealBuyLayout.vue?vue&type=script&lang=js"
export * from "./ItemFilterRealBuyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501d8f10",
  null
  
)

export default component.exports